export default __webpack_public_path__ + "static/whirligig-b1e32b223e79c42b387a316833a87010.jpeg";